module.exports = __webpack_public_path__ + "1.5.0-unryo/img/inject.583894cd.jpg";